import * as Sentry from '@sentry/vue'
import '@/styles/fonts.scss'
// By importing this all ui-library styles are loaded twice:
//   1. Globally
//   2. Within the custom element
// For now this is needed because the flyout element needs to be rendered outside the custom element because there
// are issues regarding the event bubbling.
// @TODO Remove this when there is a fix for LSelect event bubbling inside custom elements in ui-library
import '@/styles/styles.scss'

import { defineCustomElement } from 'vue'

import { APP_ID, FLYOUT_CONTAINER_ID } from '@/ts/constants/constants.ts'
import App from './App.ce.vue'
import { createPinia } from 'pinia'
import DayJsPlugin from './plugins/dayjs.plugin'

import { i18n } from '@/i18n/i18n.ts'
import { LinexoMountingError } from './ts/errors/mounting.error'

const APP_NAME = 'linexo-site-connect'

const appRootElement = document.getElementById(APP_ID)

// Throw an error in case there is no appRootElement defined
if (!appRootElement) throw new LinexoMountingError(APP_ID)

// Defines the Vue Web component
const LinexoSiteConnect = defineCustomElement(App, {
  shadowRoot: true,
  configureApp: (app) => {
    app.use(createPinia())
    app.use(DayJsPlugin)
    app.use(i18n)

    Sentry.init({
      app,
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.VITE_SENTRY_ENV,
      sendDefaultPii: true,
      enabled:
        import.meta.env.VITE_SENTRY_DSN !== undefined &&
        import.meta.env.VITE_SENTRY_ENV !== undefined
    })
  }
})

// Registers web component in browser
customElements.define(APP_NAME, LinexoSiteConnect)

// Creates linexo site connect custom element instance and adds it to appRootElements
const linexoSiteConnect = document.createElement(APP_NAME)

const flyoutContainer = document.createElement('div')
flyoutContainer.setAttribute('id', FLYOUT_CONTAINER_ID)

appRootElement.appendChild(linexoSiteConnect)
// @TODO Move the flyout container inside the App.ce.vue when LSelect selcection event bubbling was fixed for custom elements in ui-library
appRootElement.appendChild(flyoutContainer)

// Moves icon sprite into custom component shadow DOM to have icons in both scopes
const moveIconSpriteToShadowDOM = () => {
  const iconSprite = document.getElementById('linexo-svg-icon-sprite')
  if (!!iconSprite) {
    linexoSiteConnect.shadowRoot?.appendChild(iconSprite)
  } else {
    console.warn('linexo icon sprite is not available')
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(moveIconSpriteToShadowDOM, 1)
  })
} else {
  moveIconSpriteToShadowDOM()
}
